import React from 'react'
import { Link } from 'react-router-dom'
import '../../assets/custom.css'

export default function Menubar() {
  return (
    <div className='menubar w-full py-2 px-3'>
      <div className="d-flex gap-4 gap-md-4 gap-lg-5 top-scroll justify-content-md-center">
        {[
          { link: "/shop", label: "All" },
          { link: "/shop/?mc=Fashion", label: "Fashion" },
          { link: "/shop/?mc=Mobile", label: "Mobile" },
          { link: "/shop/?mc=Grocery", label: "Grocery" },
          { link: "/shop/?mc=Furnitures", label: "Furnitures" },
          { link: "/shop/?mc=Appliance", label: "Appliance" },
          { link: "/shop/?mc=Electronics", label: "Electronics" },
          { link: "/shop/?mc=Cosmetics", label: "Cosmetics" },
          { link: "/shop/?mc=Toys", label: "Toys" },
          { link: "/shop/?mc=Sports", label: "Sports" },
        ].map((item, index) => (
          <Link key={index} to={item.link} className="text-center">
            <p className="extra text-dark" style={{ fontSize: "0.9rem" }}>
              <strong>{item.label}</strong>
            </p>
          </Link>
        ))}
      </div>
    </div>
  )
}

